import { AlertItem, AlertsInfo, AlertTypeEnum } from 'domains/alertDomain';
import { Paged } from 'domains/appDomain';
import api from 'utils/api';
import { MAX_INT_VALUE } from 'utils/constants';

const alertService = {
  getAlertsInfo: () => {
    return api.get<AlertsInfo>(`/jobs/alerts/info`, undefined, undefined, {
      useGlobalErrorHandler: false,
    });
  },

  markAlertsTypeAsRead: (alertsType: AlertTypeEnum) => {
    return api.put<AlertsInfo>(`/jobs/alerts/${alertsType}`);
  },

  getAlertList: (alertsType: AlertTypeEnum) => {
    return api.get<Paged<AlertItem>>(`/jobs/alerts/list/${alertsType}`, {
      size: MAX_INT_VALUE,
    });
  },
};

export default alertService;
